import { computed } from 'vue'

import type { ComputedRef } from 'vue'
import type { Tutor } from '@brighterly/lib-core-types/tutor/interfaces'
import type { IconDefinition } from '@fortawesome/fontawesome-svg-core'

import { faCircleStar, faCircleCheck, faCircleExclamation } from '@fortawesome/pro-regular-svg-icons'

import { AttendanceRateStatus } from '@entities/tutor'

type AttendanceRateLabelColor = 'green' | 'amber' | 'red'

interface AttendanceRateLabelStatus {
  icon: IconDefinition
  value: AttendanceRateStatus
  color: AttendanceRateLabelColor
}

interface AttendanceRateLabelOptions {
  tutor: Tutor
}

interface AttendanceRateLabelReturn {
  refStatus: ComputedRef<AttendanceRateLabelStatus>
}

const getStatus = (rate: number): AttendanceRateLabelStatus => {
  if (rate >= 97) {
    return {
      icon: faCircleStar,
      value: AttendanceRateStatus.Excellent,
      color: 'green',
    }
  }

  if (rate >= 85) {
    return {
      icon: faCircleCheck,
      value: AttendanceRateStatus.OnTrack,
      color: 'amber',
    }
  }

  return {
    icon: faCircleExclamation,
    value: AttendanceRateStatus.BelowTarget,
    color: 'red',
  }
}

export const useAttendanceRateLabel = ({ tutor }: AttendanceRateLabelOptions): AttendanceRateLabelReturn => {
  const refStatus = computed<AttendanceRateLabelStatus>(() => getStatus(tutor.attendance_rate))

  return {
    refStatus,
  }
}
